import axios from "axios";

import { generateRequestConfig, projectApiUrl } from "./constants";

export type StorageObjectClass = "avatar" | "general" | "document" | "kyc_document";

export type UploadedAttachment = {
  fileId: string;
  fileName: string;
  mimeType: string;
  sizeBytes?: number;
  url?: string;
  uploadedAt?: string;
};

/**
 * The 3-step upload flow against api-storage.id.express, proxied through
 * api-pd.id.express: ticket -> PUT bytes straight to the presigned MinIO
 * URL (never through our own backend) -> complete. See
 * api-pd.id.express/backend/app/api/personal_data_attachments.py and
 * api-storage.id.express/docs/architecture.md for the full contract.
 */
export async function uploadAttachment(
  file: File,
  objectClass: StorageObjectClass,
  fieldPath: string
): Promise<UploadedAttachment> {
  const ticketConfig = generateRequestConfig("post", "personal_data_attachments", {
    fieldPath,
    objectClass,
    originalFilename: file.name,
    contentType: file.type,
    sizeBytes: file.size,
  });
  const { data: ticket } = await axios(ticketConfig);

  await axios.put(ticket.uploadUrl, file, {
    headers: { "Content-Type": file.type },
    withCredentials: false, // presigned MinIO URL, not our own session cookie
  });

  const { data: completed } = await axios.post(
    `${projectApiUrl}/personal_data/attachments/${ticket.object.id}/complete`,
    { fieldPath },
    { headers: { "X-Requested-With": "XMLHttpRequest" } }
  );

  return completed.attachment;
}
